import * as React from 'react'

import { colors } from '@flowwai-frontend/shared/style-guide'

import { IconPropsType } from '../types'

const Minimize01Icon = (props: IconPropsType): React.ReactElement => {
   const { height = 24, width = 24, fill = colors['gray-400'], ...rest } = props

   return (
      <svg
         width={width}
         height={height}
         viewBox='0 0 24 24'
         fill='none'
         xmlns='http://www.w3.org/2000/svg'
         {...rest}
      >
         <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L16.4142 9H20C20.5523 9 21 9.44772 21 10C21 10.5523 20.5523 11 20 11H14C13.4477 11 13 10.5523 13 10V4C13 3.44772 13.4477 3 14 3C14.5523 3 15 3.44772 15 4V7.58579L20.2929 2.29289ZM3 14C3 13.4477 3.44772 13 4 13H10C10.5523 13 11 13.4477 11 14V20C11 20.5523 10.5523 21 10 21C9.44772 21 9 20.5523 9 20V16.4142L3.70711 21.7071C3.31658 22.0976 2.68342 22.0976 2.29289 21.7071C1.90237 21.3166 1.90237 20.6834 2.29289 20.2929L7.58579 15H4C3.44772 15 3 14.5523 3 14Z'
            fill={fill}
         />
      </svg>
   )
}

export { Minimize01Icon }
